import { FC, useMemo } from "react";
import StarRateNewTrustScore from "../../../components/StarRate2.0";
import { IWidgetTemplate } from "../../../interfaces/widget-template";
import { ReachClick } from "../../../utils/core";
import { resolveWidgetV2Style } from "./widgetV2Styles";

/** TrustScore Banner (v2) — admin-preview-only. Real embed markup lives in widget-v2.js (renderBanner). */
const WidgetTemplate21: FC<IWidgetTemplate> = ({ company, score, style }) => {
  const companyId = company?.companyId;
  const resolvedStyle = resolveWidgetV2Style("banner", style);
  const payload = useMemo(() => ({ companyId, widgetId: 21 as const }), [companyId]);
  const profileUrl = useMemo(
    () => `https://www.trustfinance.com/companies/${companyId}?utm_source=widget&utm_medium=dom&utm_campaign=widget-v2-banner`,
    [companyId],
  );
  const licenses = company?.licenses ?? [];
  const regText = licenses.length ? `${licenses.slice(0, 3).map((l) => l.shortName || l.name).join(" · ")} regulated` : "TrustFinance verified";

  if (resolvedStyle === "slim") {
    return (
      <a
        href={profileUrl}
        target="_blank"
        rel="noopener"
        onClick={() => ReachClick(payload)}
        className="d-flex align-items-center gap-3"
        style={{ textDecoration: "none", color: "#fff", background: "linear-gradient(90deg,#006bf1,#69adff)", borderRadius: 8, padding: "8px 16px" }}
      >
        <b style={{ fontSize: 14 }}>{score?.score}/100</b>
        <StarRateNewTrustScore value={score?.score} size={10} />
        <span style={{ fontSize: 10.5, opacity: 0.9, marginLeft: "auto" }}>{(score?.totalReview ?? 0).toLocaleString()} verified reviews</span>
      </a>
    );
  }

  return (
    <a
      href={profileUrl}
      target="_blank"
      rel="noopener"
      onClick={() => ReachClick(payload)}
      className="d-flex align-items-center gap-3"
      style={{ textDecoration: "none", color: "#fff", background: "linear-gradient(90deg,#0038db,#006bf1)", borderRadius: 8, padding: "12px 16px" }}
    >
      <b style={{ fontSize: 22, lineHeight: 1 }}>{score?.score}</b>
      <div style={{ fontSize: 10, lineHeight: 1.3, opacity: 0.9 }}>TrustScore<br />/100</div>
      <div style={{ marginLeft: "auto", textAlign: "right" }}>
        <StarRateNewTrustScore value={score?.score} size={10} />
        <div style={{ fontSize: 9.5, opacity: 0.9, marginTop: 2 }}>{regText}</div>
      </div>
    </a>
  );
};

export default WidgetTemplate21;
